import React from "react";
import { useNavigate } from "react-router-dom";
import SafeHtml from "components/shared/SafeHtml";
import TncHeader from "../Header/TncHeader";
import { strings } from "../../../utils/constants/strings";
import styles from "./PackagingLabelsTnc.module.scss";

const PackagingLabelsTnc = () => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            <TncHeader />
            <div className={styles.page}>
                <div className={styles.content}>
                    <h4 className={styles.heading}>{strings.packagingLabelsTncHeading}</h4>
                    <div className={styles.body}>
                        <SafeHtml tag="p" html={strings.packagingLabelsTncIntro} />
                        <SafeHtml html={strings.packagingLabelsTncListItems} />
                    </div>
                </div>
                <div className={styles.footerBar}>
                    <button
                        className={styles.okayBtn}
                        onClick={() => navigate("/download-labels/compliance")}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PackagingLabelsTnc;
